import basicRepository from '../../../lib/basicRepository';
import { restApi } from '../../../services/api';
import {
  FindSharedEntityByEntityParams,
  IDeleteSharedEntityDto,
  IGetSharedEntityResponse,
  ISharedEntityDto,
  SharedEntityCreatedData,
} from '../types/sharedEntities.types';

const PATH = 'shared-entities';
export const sharedEntitiesRepository = () =>
  basicRepository({
    path: PATH,
    restApi,
  });

export const createLink = (payload: ISharedEntityDto) =>
  restApi.post<SharedEntityCreatedData>(PATH, payload);

export const updateLink = (payload: ISharedEntityDto) => restApi.put<string>(PATH, payload);

export const deleteLinks = (payload: IDeleteSharedEntityDto) => restApi.delete(PATH, payload);

export const validateLink = (publicId: string) =>
  restApi.get<IGetSharedEntityResponse>(`${PATH}/validate/${publicId}`);

export const findSharedEntityByEntity = (params: FindSharedEntityByEntityParams) =>
  restApi.get<boolean>(PATH, params);
